exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expl{position:absolute;right:0;bottom:0;text-transform:uppercase;font-size:8px;background-color:hsla(0,0%,78%,.7);color:#404040;padding-left:2px;padding-right:2px;border-top-left-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71f1ff98","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Advertisement.vue
// module id = dUfM
// module chunks = 36